<template>
  <main>
    <Transition name="fade">
      <div v-if="page">
        <PageHeader :content="page.data.header"/>
        <PageSections :sections="page.data.sections"/>
      </div>
    </Transition>
  </main>
</template>

<script lang="ts">
import {ViewDataMixin} from '@/views/mixins'
import {PageHeader, PageSections} from '@/components/sections'
import {usePageStore} from '@/stores'

export default {
  name: 'AboutPage',
  mixins: [ViewDataMixin],
  components: {PageHeader, PageSections},
  data() {
    return {
      page: null as Page | null
    }
  },
  methods: {
    async init() {
      const page = await usePageStore().get('about')

      if (!page) {
        return await this.$router.push({name: this.$routes.NOT_FOUND})
      }

      this.page = page
    }
  }
}
</script>